import styled from 'styled-components'
import { H2Alt } from 'src/styles/Typography'
import SvgTarget from 'src/components/icons/Target'

function KeyTakeaways({ keyTakeaways }) {
  if (!keyTakeaways) return null
  return (
    <KeyTakeawaysWrapper>
      <StyledH2>
        <SvgTarget /> Key Takeaways
      </StyledH2>
      <ul>
        {keyTakeaways.map((takeaway, index) => (
          <li key={index}>{takeaway}</li>
        ))}
      </ul>
    </KeyTakeawaysWrapper>
  )
}

export default KeyTakeaways

const StyledH2 = styled(H2Alt)`
  svg {
    margin: 0 21px -5px 0;
  }
`

const KeyTakeawaysWrapper = styled.div`
  margin: 1rem 0 2.5rem 3rem;
  padding: 2.5rem 3rem 3rem;
  background: white;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  font-size: 14px;
  line-height: 24px;

  ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem 2.5rem;
    margin-top: 2rem;
    padding-left: 1rem;

    li {
      padding-left: 0.5rem;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
      grid-template-columns: 1fr;
      margin-top: 1.5rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-left: 0;
    padding: 1.5rem 1.5rem 2rem;
  }
`
